import React, { Component } from 'react'
import { Button, Checkbox, Modal } from 'antd'
import numeral from 'numeral'
import _ from 'lodash'

import './QuotationItemListModal.scss'

export default class QuotationItemListModal extends Component {
    getItemTotal(item) {
        const { quantity, basic_charge, basic_charge_quantity, unit_rate } = item
        if (basic_charge && basic_charge_quantity) {
            if (basic_charge_quantity >= quantity)
                return basic_charge
            else
                return basic_charge + (quantity - basic_charge_quantity) * unit_rate
        } else {
            return quantity * unit_rate
        }
    }

    getSectionTotal(itemList) {
        let total = 0;

        _.map(itemList, (item, idx) => {
            total += this.getItemTotal(item)
        })

        return total
    }

    renderItemRow(sectionIdx, itemList) {
        const { onItemCheck } = this.props

        return _.map(itemList, (item, itemIdx) => {
            const { name, quantity, basic_charge_quantity, basic_charge, unit_rate, unit, checked } = item
            return (
                <tr key={`${sectionIdx}-${itemIdx}`}>
                    <td><Checkbox checked={checked} onChange={onItemCheck.bind(this, sectionIdx, itemIdx)}></Checkbox></td>
                    <td>{sectionIdx + 1}.{itemIdx + 1}</td>
                    <td>
                        <div className="table-item">{name}</div>
                    </td>
                    <td>
                        <div className="table-item">{quantity}</div>
                    </td> 
                    <td width={80}>
                        <div className="table-item">
                            {basic_charge_quantity && `First ${basic_charge_quantity}`}
                        </div>
                    </td>
                    <td width={80}>
                        <div className="table-item">
                            {basic_charge && `$ ${numeral(basic_charge).format('0,0')}`}
                        </div>
                    </td>
                    <td width={80}>
                        <div className="table-item">
                            {unit_rate && `$ ${numeral(unit_rate).format('0,0')}`}
                        </div> 
                    </td>
                    <td width={60}>{unit}</td>
                    <td>
                        <div className="table-item">
                            {numeral(this.getItemTotal(item)).format('$ 0,0')}
                        </div>
                    </td>
                </tr>
            )
        })
    }

    renderSectionRow() {
        const sections = this.props.mainQuotation.sections || []

        if (sections.length !== 0)
            return _.map(sections, (section, sectionIdx) => (
                <div className="section" key={sectionIdx}>
                    <div className="section-header">
                        <div className="section-idx">{sectionIdx + 1}.0</div>
                        <div className="section-name">{section.name}</div>
                    </div>
                    <table className={`item-table${section.toggled ? ' toggled' : ''}`}>
                        <thead>
                            <tr>
                                <th width={40}></th>
                                <th width={40}></th>
                                <th>Item</th>
                                <th width={80}>Qty</th>
                                <th width={80} colSpan={2}>Basic Charge</th>
                                <th width={80} colSpan={2}>Unit Rate</th>
                                <th width={120}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderItemRow(sectionIdx, section.items)}
                        </tbody>
                    </table>
                </div>
            ))
    }

    render() {
        const { visible, onCancel, modalBtnText, onSubmit } = this.props

        return (
            <Modal
                width="60%"
                wrapClassName="QuotationItemListModal"
                visible={visible}
                footer={null}
                onCancel={onCancel}
            >
                <p className="label">Please check the items that you want to import:</p>
                <div className="item-list">
                    {this.renderSectionRow()}
                </div>
                <div className="footer">
                    <Button type="primary" size="large" onClick={onSubmit}>{modalBtnText}</Button>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/QuotationItemListModal/QuotationItemListModal.js